var render, staticRenderFns
import script from "./VueSfcEditor.vue?vue&type=script&lang=js"
export * from "./VueSfcEditor.vue?vue&type=script&lang=js"
import style0 from "./VueSfcEditor.vue?vue&type=style&index=0&id=26a4126c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports